import { BurpEffect } from 'game/extended/creatures/goblins/abilities/burp/burp_effect'

export default {
    events: {},
    effects: {
        BurpEffect
    },
}